export default __webpack_public_path__ + "static/media/Gauntlets of the Proven Champion.3445fb2a.jpg";